import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadContractRevenueRentLimitsStatus: 'idle',
    loadContractRevenueRentLimitsError: undefined as any,
    loadContractRevenueRentLimitsLastArgs: undefined as any,
    loadContractRevenueRentLimitStatus: 'idle',
    loadContractRevenueRentLimitError: undefined as any,
    saveContractRevenueRentLimitStatus: 'idle',
    saveContractRevenueRentLimitError: undefined as any,
    deleteContractRevenueRentLimitStatus: 'idle',
    deleteContractRevenueRentLimitError: undefined as any,

    fluklList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadContractRevenueRentLimits = createAsyncThunk('revenueRentLimitSlice/loadContractRevenueRentLimits', async ({ flust, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().revenueRentLimitSlice.loadContractRevenueRentLimitsLastArgs
    if (_.isEqual(lastArgs, { flust }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/flukl/?USTID=${flust.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { flust }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractRevenueRentLimitsStatus } = getState().revenueRentLimitSlice
        return loadContractRevenueRentLimitsStatus !== 'pending'
    }
})

export const loadContractRevenueRentLimit = createAsyncThunk('revenueRentLimitSlice/loadContractRevenueRentLimit', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flukl/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractRevenueRentLimitStatus } = getState().revenueRentLimitSlice
        return loadContractRevenueRentLimitStatus !== 'pending'
    }
})

export const saveContractRevenueRentLimit = createAsyncThunk('revenueRentLimitSlice/saveContractRevenueRentLimit', async ({ flukl }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flukl?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/flukl/${ flukl?.HDR_ID }/`,
            prepareData(flukl),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/flukl/`,
            prepareData(flukl),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveContractRevenueRentLimitStatus } = getState().revenueRentLimitSlice
        return saveContractRevenueRentLimitStatus !== 'pending'
    }
})

export const deleteContractRevenueRentLimit = createAsyncThunk('revenueRentLimitSlice/deleteContractRevenueRentLimit', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flukl/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteContractRevenueRentLimitStatus } = getState().revenueRentLimitSlice
        return deleteContractRevenueRentLimitStatus !== 'pending'
    }
})

const FluklSlice = createSlice({
    name: 'revenueRentLimitSlice',
    initialState,
    reducers: {
        resetloadContractRevenueRentLimitsError: (state) => {
            state.loadContractRevenueRentLimitsError = undefined
        },
        resetloadContractRevenueRentLimit: (state) => {
            state.formItem = undefined
            state.loadContractRevenueRentLimitError = undefined
        },
        resetloadContractRevenueRentLimitError: (state) => {
            state.loadContractRevenueRentLimitError = undefined
        },
        resetsaveContractRevenueRentLimit: (state) => {
            state.formItem = undefined
            state.saveContractRevenueRentLimitError = undefined
        },
        resetsaveContractRevenueRentLimitError: (state) => {
            state.saveContractRevenueRentLimitError = undefined
        },
        resetdeleteContractRevenueRentLimitError: (state) => {
            state.deleteContractRevenueRentLimitError = undefined
        },
        removeFromFluklListById: (state, action) => {
            state.fluklList = state.fluklList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFluklListByIds: (state, action) => {
            state.fluklList = state.fluklList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.fluklList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadContractRevenueRentLimitsStatus = 'preloaded'
            state.loadContractRevenueRentLimitsLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.fluklList = []
            state.loadContractRevenueRentLimitsStatus = 'idle'
            state.loadContractRevenueRentLimitsLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadContractRevenueRentLimits.pending, (state) => {
            state.loadContractRevenueRentLimitsStatus = 'pending'
            state.loadContractRevenueRentLimitsError = undefined
        })
        builder.addCase(loadContractRevenueRentLimits.fulfilled, (state, action) => {
            state.loadContractRevenueRentLimitsStatus = 'idle'

            if (!action.payload) { return }

            state.loadContractRevenueRentLimitsLastArgs = action.payload.args

            {
                state.fluklList = action.payload.data

            }
        })
        builder.addCase(loadContractRevenueRentLimits.rejected, (state, action) => {
            state.loadContractRevenueRentLimitsStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractRevenueRentLimitsError = action.error.message
            } else {
                state.loadContractRevenueRentLimitsError = action.payload
            }
        })

        builder.addCase(loadContractRevenueRentLimit.pending, (state) => {
            state.loadContractRevenueRentLimitStatus = 'pending'
            state.loadContractRevenueRentLimitError = undefined
        })
        builder.addCase(loadContractRevenueRentLimit.fulfilled, (state, action) => {
            state.loadContractRevenueRentLimitStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.fluklList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.fluklList.push(newItem) }
                else { state.fluklList[i] = { ...state.fluklList[i], ...newItem } }
            }
        })
        builder.addCase(loadContractRevenueRentLimit.rejected, (state, action) => {
            state.loadContractRevenueRentLimitStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractRevenueRentLimitError = action.error.message
            } else {
                state.loadContractRevenueRentLimitError = action.payload
            }
        })

        builder.addCase(saveContractRevenueRentLimit.pending, (state) => {
            state.saveContractRevenueRentLimitStatus = 'pending'
            state.saveContractRevenueRentLimitError = undefined
        })
        builder.addCase(saveContractRevenueRentLimit.fulfilled, (state, action) => {
            state.saveContractRevenueRentLimitStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.fluklList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.fluklList.push(newItem) }
                else { state.fluklList[i] = { ...state.fluklList[i], ...newItem } }
            }
        })
        builder.addCase(saveContractRevenueRentLimit.rejected, (state, action) => {
            state.saveContractRevenueRentLimitStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveContractRevenueRentLimitError = action.error.message
            } else {
                state.saveContractRevenueRentLimitError = action.payload
            }
        })

        builder.addCase(deleteContractRevenueRentLimit.pending, (state) => {
            state.deleteContractRevenueRentLimitStatus = 'pending'
            state.deleteContractRevenueRentLimitError = undefined
        })
        builder.addCase(deleteContractRevenueRentLimit.fulfilled, (state, action) => {
            state.deleteContractRevenueRentLimitStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.fluklList = state.fluklList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.fluklList = state.fluklList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteContractRevenueRentLimit.rejected, (state, action) => {
            state.deleteContractRevenueRentLimitStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteContractRevenueRentLimitError = action.error.message
            } else {
                state.deleteContractRevenueRentLimitError = action.payload
            }
        })

    }
})

export const {
    resetloadContractRevenueRentLimitsError,
    resetloadContractRevenueRentLimit,
    resetloadContractRevenueRentLimitError,
    resetsaveContractRevenueRentLimit,
    resetsaveContractRevenueRentLimitError,
    resetdeleteContractRevenueRentLimitError,
    removeFromFluklListById,
    removeFromFluklListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FluklSlice.actions
export default FluklSlice.reducer
